import { booleanize } from '../utilities';
import { AdminApiService } from '../services/general';
import type { ContactCreate, ContactUpdate } from '../services/general';

export type GetContactsFilters = {
  email?: string | null;
  phone?: string | null;
  campaignId?: string | null;
  requiresHumanInput?: BooleanString;
};

export const getAllContacts = () => {
  return AdminApiService.getContactsApiAdminContactsGet(
    undefined,
    undefined,
    undefined,
    undefined,
    1_000,
    undefined
  );
};

export const getContacts = (
  filters: GetContactsFilters,
  page: PaginationType
) => {
  return AdminApiService.getContactsApiAdminContactsGet(
    filters?.email,
    filters?.phone,
    filters?.campaignId,
    booleanize(filters.requiresHumanInput),
    page?.limit,
    page?.offset
  );
};

export const addContact = (payload: ContactCreate) => {
  return AdminApiService.createContactApiAdminContactsPost(payload);
};
export const updateContact = (id: string, payload: ContactUpdate) => {
  return AdminApiService.updateContactApiAdminContactsContactIdPatch(
    id,
    payload
  );
};
export const deleteContact = (id: string) => {
  return AdminApiService.deleteContactApiAdminContactsContactIdDelete(id);
};
export const startCampaignForContact = (payload: StartCampaignForContact) => {
  return AdminApiService.startCampaignAdminApiAdminCampaignsStartPost(payload);
};
export const wipeContact = (id: string) => {
  return AdminApiService.cleanContactDataApiAdminContactsContactIdCleanPost(id);
};

export type { ContactResponse as ContactItem } from '../services/general';
export type ContactCreatePayload = ContactCreate;
export type ContactUpdatePayload = ContactUpdate;
export type StartCampaignForContact = {
  campaign_strategy: string;
  contact_id: string;
  user_email: string;
};
